// src/components/About.jsx
import React from "react";
import "./About.css";

function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            {/* Możesz tu użyć innego zdjęcia */}
            <img src="/images/mama-zdjecie.jpg" alt="Zdjęcie 1" />
          </div>
          <div className="about-text">
            <div className="section-title" style={{ textAlign: "left" }}>
              <h2 style={{ display: "block" }}>
                Kilka słów o mnie
                <span
                  style={{
                    left: "0",
                    transform: "none",
                    bottom: "-15px",
                  }}
                ></span>
              </h2>
            </div>
            <p>
              Matematyka to moja pasja, którą od lat dzielę się z uczniami.
              Wierzę, że kluczem do sukcesu jest indywidualne podejście i
              zbudowanie pewności siebie, ponieważ to dzięki niej uczeń nie tylko nauczy się materiału, ale też faktycznie go zrozumie.
            </p>
            <div className="about-details">
              <p>
                <strong>Specjalizacja:</strong> Przygotowanie do egzaminów takich jak matura czy egzamin ósmoklasisty, oraz klasycznych sprawdzianów i kartkówek z poszczególnych działów.
              </p>
              <p>
                <strong>Forma zajęć:</strong> Online przy pomocy tableta graficznego poprzez aplikację Discord
              </p>
              <p>
                <strong>Poziomy:</strong> Szkoła podstawowa i średnia
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;